import React from 'react'
import QuizData from './Elements/QuizData';
import { useTranslation } from "react-i18next";
import ReactMarkdown from 'react-markdown';
export default function Quiz() {
  const { t } = useTranslation(["quizzPageAgency"]);

  const [showForResult, setShowForResult] = React.useState(false);
    const showHeader = () => {
  setShowForResult(true);
    }
  return (
    <div>
       <section className="header2 theme-space px-lg-5 autofocus">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-10">
              <div className="text-wrapper">
                 {showForResult ? (
                                    Object.values(t("topContent", { returnObjects: true })).map(
                                      (item) =>
                                          item.fieldType === "h1" && item.value !== "" && item?.isFor === "result"? (
                                          <h1 key={item.id} className="mb-5">
                                            <ReactMarkdown components={{ p: React.Fragment, h1: React.Fragment, h2: React.Fragment, h3: React.Fragment, h4: React.Fragment, h5: React.Fragment, h6: React.Fragment }}>
                                              {item.value}
                                             </ReactMarkdown>
                                          </h1>
                                      ) : (
                                      ""
                                    )
                                )) : (
                                  Object.values(t("topContent", { returnObjects: true })).map(
                                  (item) =>
                                    item.fieldType === "h1" && item.value !== "" && item?.isFor === "quizz" ? (
                                      <h1 key={item.id} className="mb-5">
                                        <ReactMarkdown components={{ p: React.Fragment, h1: React.Fragment, h2: React.Fragment, h3: React.Fragment, h4: React.Fragment, h5: React.Fragment, h6: React.Fragment }}>
                                          {item.value}
                                        </ReactMarkdown>
                                      </h1>
                                    ) : (
                                      ""
                                    )
                                )
                                )}
                {showForResult ? (
                
                Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "plain_text" && item.value !== "" && item?.isFor === "result" ? (
                      <p
                        key={item.id}
                        className="col-12 col-md-8 pe-lg-5 me-lg-5 page3topplainteext"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </p>
                    ) : (
                      ""
                    )
                )) : (
                  Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "plain_text" && item.value !== ""  && item?.isFor === "quizz" ? (
                      <p
                        key={item.id}
                        className="col-12 col-md-8 pe-lg-5 me-lg-5 page3topplainteext"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </p>
                    ) : (
                    ""
                                    )
                                )
                                )}
              </div>
            </div>
            <div className="col-12 col-md-2 col-lg-2"> </div>
          </div>
        </div>
      </section>
      <section className="theme-space px-lg-5 mb-3">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div>
              <div className="text-wrapper">
                <QuizData showHeader={showHeader}/>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7 image-wrapper"> </div>
          </div>
        </div>
      </section>
    </div>
  )
}
